import {home} from './forumModule/home'
import {about} from './forumModule/about'
import {project} from './forumModule/project'
import {news} from './forumModule/news'
import {contact} from './forumModule/contact'
const forumRoutes = [
    ...home,
    ...about,
    ...project,
    ...news,
    ...contact
]

export default forumRoutes